// extracted by mini-css-extract-plugin
export var contentContainer = "styles-module--contentContainer--dKcTx";
export var photoAtelier = "styles-module--photoAtelier--5s+y9";
export var presentation = "styles-module--presentation--7xDv8";
export var title = "styles-module--title--SP2uR";
export var titleAtelier = "styles-module--titleAtelier--K3xBS";